import Repository from './Repository';
import InstanceRepository from './InstanceRepository';

import { vue } from '../main';

const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/live`;

export default {
  /**
   * Initializes live mode in the currently acquired instance and locks live mode for the entire channel.
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  init() {
    return Repository.get(`${base}/init`).then((response) => {
      InstanceRepository.refetchActive(false);
      vue.$snotify.info(vue.$t('UI_LIVE_MODE_INITIALIZED'));
      vue.$store.commit('sidePanelVideoLiveStreamToggle');
      return Promise.resolve(response);
    }).catch(error => Promise.reject(error));
  },
  /**
   * Starts the timer and initiates the recording of the preconfigured livestreams. Can also be used to resume a previously paused live session.
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  start() {
    return Repository.get(`${base}/start`).then((response) => {
      InstanceRepository.refetchActive(false);
      return Promise.resolve(response);
    }).catch(error => Promise.reject(error));
  },

  /**
   * Pauses the currently running live session.
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  pause() {
    return Repository.get(`${base}/pause`).then((response) => {
      InstanceRepository.refetchActive(false);
      return Promise.resolve(response);
    }).catch(error => Promise.reject(error));
  },

  /**
   * Stops all recordings permanently within the current live session.
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  stop() {
    return Repository.get(`${base}/stop`).then((response) => {
      InstanceRepository.refetchActive(false);
      return Promise.resolve(response);
    }).catch(error => Promise.reject(error));
  },

  /**
   * Ends the current live session within currently acquired instance and frees live mode for the entire channel.
   * Once this endpoint is called, the recorded video (if present) is automatically imported into the multimedia platform.
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  clear() {
    return Repository.get(`${base}/clear`).then((response) => {
      InstanceRepository.refetchActive(false);
      vue.$snotify.info(vue.$t('UI_LIVE_MODE_CLEARED'));
      vue.$store.commit('sidePanelVideoLiveStreamToggle');
      Promise.resolve(response);
    }).catch(error => Promise.reject(error));
  },

  /**
   * Imports the resulting video record of the live session's main livestream into the multimedia backend, straight into the channel.
   * This endpoint can only be called once the live session has been stopped.
   * Once the video is imported and converted, it will appear in the list of available media.
   * @returns {Promise<AxiosResponse<T>>}
   */
  import(categoriesArray) {
    return Repository.post(`${base}/import`, { categories: categoriesArray }).then((response) => {
      vue.$snotify.info(vue.$t('UI_LIVE_MODE_IMPORTED'));
      Promise.resolve(response);
    }).catch(error => Promise.reject(error));
  },
};
